// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_4zd","cls2":"LoswpPackPitch-cls2_SXu LoswpPackPitch-cls1_4zd"};